<template>
  <li>
    <router-link :to="{ name: 'agencies.edit', params: { id: agency.id } }">
      <div class="row">
        <div class="col">
          {{ agency.name }}
        </div>
        <div class="col-auto">
          <span v-if="agencyIsEnabled" class="status status-success">Enabled</span>
          <span v-if="agencyIsDisabled" class="status status-danger">Disabled</span>
        </div>
      </div><!-- /.row -->
    </router-link>
  </li>
</template>

<script>
export default {
  props: {
    agency: {
      required: true,
      type: Object
    }
  },

  computed: {
    agencyIsEnabled () {
      return this.agency.enabled === true
    },

    agencyIsDisabled () {
      return this.agency.enabled === false
    }
  }
}
</script>
